function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== 'undefined' && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base)
                return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
        object = _getPrototypeOf(object);
        if (object === null)
            break;
    }
    return object;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
import Tech from './tech.js';
import * as Dom from '@emav-util/dom.js';
import * as Url from '@emav-util/url.js';
import log from '@emav-util/log.js';
import tsml from 'tsml';
import * as browser from '@emav-util/browser.js';
import document from 'global/document';
import window from 'global/window';
import { assign } from '@emav-util/obj';
import mergeOptions from '@emav-util/merge-options.js';
import toTitleCase from '@emav-util/to-title-case.js';
import { NORMAL as TRACK_TYPES } from '../tracks/track-types';
import setupSourceset from './setup-sourceset';
import HLSjs from 'hls.js';
var HLS = function (_Tech) {
    _inherits(HLS, _Tech);
    function HLS(options, ready) {
        var _arguments = arguments;
        var _this2;
        _classCallCheck(this, HLS);
        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(HLS).call(this, options, ready));
        var source = options.source;
        console.log('[hls.js][]', options, ready, _assertThisInitialized(_this2), _this2.el_, options.el);
        var _this = _assertThisInitialized(_this2);
        var hlsPlayer = new HLSjs();
        _this.hlsPlayer = hlsPlayer;
        hlsPlayer.on(HLSjs.Events.MANIFEST_LOADED, function () {
            console.log('\u3010MEDIA_INFO\u3011~~~~~~~~~~~~~~~~', _arguments, _this.hlsPlayer.duration);
        });
        hlsPlayer.on(HLSjs.Events.MANIFEST_PARSED, function () {
            console.log('\u3010MANIFEST_LOADED\u3011~~~~~~~~~~~~~~~~', arguments);
        });
        hlsPlayer.loadSource(source.src);
        hlsPlayer.attachMedia(_this2.el_);
        _this2.triggerReady();
        return _this2;
    }
    _createClass(HLS, [
        {
            key: 'play',
            value: function play() {
                this.hlsPlayer.play();
            }
        },
        {
            key: 'setCurrentTime',
            value: function setCurrentTime(seconds) {
                try {
                    this.el_.currentTime = seconds;
                } catch (e) {
                    log(e, 'Video is not ready. (emav.js)');
                }
            }
        },
        {
            key: 'duration',
            value: function duration() {
                var _this3 = this;
                if (this.el_.duration === Infinity && browser.IS_ANDROID && browser.IS_CHROME && this.el_.currentTime === 0) {
                    var checkProgress = function checkProgress() {
                        if (_this3.el_.currentTime > 0) {
                            if (_this3.el_.duration === Infinity) {
                                _this3.trigger('durationchange');
                            }
                            _this3.off('timeupdate', checkProgress);
                        }
                    };
                    this.on('timeupdate', checkProgress);
                    return NaN;
                }
                return this.el_.duration || NaN;
            }
        },
        {
            key: 'setSource',
            value: function setSource(source) {
                console.log('HLS.js - setSource:', source);
            }
        },
        {
            key: 'dispose',
            value: function dispose() {
                this.hlsPlayer.detachMedia();
                this.hlsPlayer.destroy();
                _get(_getPrototypeOf(HLS.prototype), 'dispose', this).call(this);
            }
        }
    ]);
    return HLS;
}(Tech);
[
    'muted',
    'defaultMuted',
    'autoplay',
    'controls',
    'loop',
    'playsinline'
].forEach(function (prop) {
    HLS.prototype[prop] = function () {
        return this.el_[prop] || this.el_.hasAttribute(prop);
    };
});
[
    'muted',
    'defaultMuted',
    'autoplay',
    'loop',
    'playsinline'
].forEach(function (prop) {
    HLS.prototype['set' + toTitleCase(prop)] = function (v) {
        this.el_[prop] = v;
        if (v) {
            this.el_.setAttribute(prop, prop);
        } else {
            this.el_.removeAttribute(prop);
        }
    };
});
[
    'paused',
    'currentTime',
    'buffered',
    'volume',
    'poster',
    'preload',
    'error',
    'seeking',
    'seekable',
    'ended',
    'playbackRate',
    'defaultPlaybackRate',
    'played',
    'networkState',
    'readyState',
    'videoWidth',
    'videoHeight'
].forEach(function (prop) {
    HLS.prototype[prop] = function () {
        return this.el_[prop];
    };
});
[
    'volume',
    'src',
    'poster',
    'preload',
    'playbackRate',
    'defaultPlaybackRate'
].forEach(function (prop) {
    HLS.prototype['set' + toTitleCase(prop)] = function (v) {
        this.el_[prop] = v;
    };
});
[
    'pause',
    'load',
    'play'
].forEach(function (prop) {
    HLS.prototype[prop] = function () {
        return this.el_[prop]();
    };
});
HLS.canPlayType = function (type) {
    console.log('[HLS][canPlayType]:', arguments);
    if (type in HLS.formats) {
        return 'maybe';
    }
    return '';
};
HLS.formats = { 'application/x-mpegurl': 'm3u8' };
HLS.isSupported = function () {
    console.log('[HLS][isSupported]:', arguments);
    return HLSjs.isSupported();
};
Tech.withSourceHandlers(HLS);
HLS.nativeSourceHandler = { name: 'HLS' };
HLS.nativeSourceHandler.canPlayType = function (type) {
    if (type in HLS.formats) {
        return 'maybe';
    }
    return '';
};
HLS.nativeSourceHandler.canHandleSource = function (source, options) {
    var type;
    function guessMimeType(src) {
        var ext = Url.getFileExtension(src);
        if (ext) {
            return 'video/'.concat(ext);
        }
        return '';
    }
    if (!source.type) {
        type = guessMimeType(source.src);
    } else {
        type = source.type.replace(/;.*/, '').toLowerCase();
    }
    return HLS.nativeSourceHandler.canPlayType(type);
};
HLS.nativeSourceHandler.handleSource = function (source, tech, options) {
    tech.setSrc(source.src);
};
HLS.nativeSourceHandler.dispose = function () {
    this.hlsPlayer.detachMedia();
    this.hlsPlayer.destroy();
};
HLS.registerSourceHandler(HLS.nativeSourceHandler);
Tech.registerTech('HLS', HLS);
export default HLS;